// extracted by mini-css-extract-plugin
module.exports = {"section":"embed_section__V4WGB","visual":"embed_visual__O_fHd","iframe":"embed_iframe__s4FpA"};